module.exports = __webpack_public_path__ + "img/gys_29@2x.1b48cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_29@2x.png
// module id = zDTD
// module chunks = 0